import {useDeleteTaskDialogOptional} from '../contexts/DeleteTaskDialogContext'
import {DeleteTaskDialog} from './DeleteTaskDialog'

interface DeleteTaskDialogRenderedProps {
  /** When true, navigates back to the task list after deletion (used on task view page) */
  navigateOnDelete?: boolean
  /** Optional task ID that should trigger navigation after deletion. */
  navigateOnDeleteTaskId?: string
  deletionDestination?: string
  onDeleteSuccess?: (taskId: string) => void
}

export function DeleteTaskDialogRendered({
  navigateOnDelete,
  navigateOnDeleteTaskId,
  deletionDestination,
  onDeleteSuccess,
}: DeleteTaskDialogRenderedProps) {
  const deleteDialog = useDeleteTaskDialogOptional()
  if (!deleteDialog?.dialogState.isOpen || !deleteDialog.dialogState.taskId) return null
  const {taskId, repoOwner, repoName} = deleteDialog.dialogState
  const shouldNavigateOnDelete =
    navigateOnDelete || (navigateOnDeleteTaskId != null && taskId === navigateOnDeleteTaskId)
  return (
    <DeleteTaskDialog
      taskId={taskId}
      repoOwner={repoOwner}
      repoName={repoName}
      apiUrl={deleteDialog.chatApiUrl}
      closeDialog={deleteDialog.closeDeleteDialog}
      navigateOnDelete={shouldNavigateOnDelete}
      deletionDestination={deletionDestination}
      onDeleteSuccess={onDeleteSuccess}
    />
  )
}
